import React, { Component } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import {
  addKeyword,
  removeCity,
  removeCompany,
  removeCountry,
  removeKeyword,
  removeLocation,
  updateKeywordSearchTerm,
} from 'src/actions/companySearch';
import {
  getCompanySearchSelectedKeyword,
  getCompanySearchTermKeyword,
  getSelectedCityIds,
  getSelectedCompanies,
  getSelectedCountries,
  getSelectedLocations,
} from 'src/selectors/companySearch';

import * as Styled from './FilterSearchTerm.sc';

class FilterSearchTerm extends Component {
  static propTypes = {
    updateKeywordSearchTerm: PropTypes.func,
    addKeyword: PropTypes.func,
    removeCity: PropTypes.func,
    removeLocation: PropTypes.func,
    removeCompany: PropTypes.func,
    removeCountry: PropTypes.func,
    removeKeyword: PropTypes.func,
    onCitiesChanged: PropTypes.func,
    onCompaniesChanged: PropTypes.func,
    onCountriesChanged: PropTypes.func,
    onKeywordChanged: PropTypes.func,

    selectedCities: PropTypes.array,
    selectedLocations: PropTypes.array,
    selectedCompanies: PropTypes.array,
    selectedKeywords: PropTypes.array,
    selectedCountries: PropTypes.array,

    searchTermKeyword: PropTypes.string,
    colours: PropTypes.shape({
      primary: PropTypes.string,
      secondary: PropTypes.string,
    }),
  };

  onSearchTermChanged = e => {
    this.props.updateKeywordSearchTerm(e.target.value);
  };

  onKeywordConfirmed = async e => {
    if (e.key === 'Enter') {
      this.props.updateKeywordSearchTerm('');
      await this.props.addKeyword(this.props.searchTermKeyword);
      this.props.onKeywordChanged();
    }
  };

  processTags() {
    return []
      .concat(
        this.props.selectedCities.map(c => {
          if (c) {
            c.type = 'city';
          }
          return c;
        })
      )
      .concat(
        this.props.selectedLocations.map(c => {
          if (c) {
            c.type = 'locations';
          }
          return c;
        })
      )
      .concat(
        this.props.selectedCompanies.map(c => {
          if (c) {
            c.type = 'company';
          }
          return c;
        })
      )
      .concat(
        this.props.selectedCountries.map(c => {
          if (c) {
            c.type = 'country';
          }
          return c;
        })
      )
      .concat(
        this.props.selectedKeywords.map(keyword => ({
          type: 'keyword',
          name: keyword,
        }))
      )
      .filter(t => t && t.type && t.name);
  }

  handleClose = async removedTag => {
    switch (removedTag.type) {
      case 'city':
        await this.props.removeCity(removedTag.id);
        this.props.onCitiesChanged();
        break;
      case 'locations':
        await this.props.removeLocation(removedTag.id);
        this.props.onCitiesChanged();
        break;
      case 'company':
        await this.props.removeCompany(removedTag.id);
        this.props.onCompaniesChanged();
        break;
      case 'country':
        await this.props.removeCountry(removedTag.code);
        this.props.onCountriesChanged();
        break;
      case 'keyword':
        await this.props.removeKeyword(removedTag.name);
        this.props.onKeywordChanged();
        break;
    }
  };

  render() {
    const tags = this.processTags();
    const { searchTermKeyword, colours } = this.props;

    return (
      <Styled.SearchWrapper>
        <Styled.SearchIcon />
        <For each="tag" of={tags}>
          <Styled.Tag
            key={`${tag.type}-${tag.id}-${tag.name}`}
            bgColor={get(colours, 'primary')}
          >
            {tag.name}
            <Styled.CloseIcon onClick={() => this.handleClose(tag)} />
          </Styled.Tag>
        </For>
        <Styled.InputWrapper>
          <FormattedMessage id="enter.keywords" defaultMessage="Enter keywords">
            {msg => (
              <Styled.Input
                placeholder={msg}
                value={searchTermKeyword}
                type="text"
                onChange={this.onSearchTermChanged}
                onKeyPress={this.onKeywordConfirmed}
              />
            )}
          </FormattedMessage>
        </Styled.InputWrapper>
      </Styled.SearchWrapper>
    );
  }
}

FilterSearchTerm = connect(
  state => ({
    searchTermKeyword: getCompanySearchTermKeyword(state),
    selectedCities: getSelectedCityIds(state),
    selectedLocations: getSelectedLocations(state),
    selectedCompanies: getSelectedCompanies(state),
    selectedKeywords: getCompanySearchSelectedKeyword(state),
    selectedCountries: getSelectedCountries(state),
  }),
  {
    updateKeywordSearchTerm,
    addKeyword,
    removeKeyword,
    removeCity,
    removeLocation,
    removeCompany,
    removeCountry,
  }
)(FilterSearchTerm);

export default FilterSearchTerm;
